import { buttonRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const Button = styled('button', buttonRecipe);
export type ButtonProps = HTMLStyledProps<typeof Button>;
